import { render, staticRenderFns } from "./soundWave.vue?vue&type=template&id=7afabc84&scoped=true&"
import script from "./soundWave.vue?vue&type=script&lang=js&"
export * from "./soundWave.vue?vue&type=script&lang=js&"
import style0 from "./soundWave.vue?vue&type=style&index=0&id=7afabc84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afabc84",
  null
  
)

export default component.exports